import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 20,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [2, 5, 4], mass: 20, type: 'Box' },
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 0, 0]} args={[2, 5, 4]} color="#2a2a2a"/>
    </group>
  );
};
